// eslint-disable-next-line no-unexpected-multiline
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const hyperLinks = Array.from(document.getElementsByTagName('a'))
    hyperLinks.forEach((element: HTMLAnchorElement) => {
      const targetElement: string | null = element.getAttribute('href')
      /* /external/interstitial find the list of target element */
      if (targetElement !== null && targetElement !== '') {
        const interstitialLink = /external\/interstitial/g
        const interstitialLinksFound: RegExpMatchArray | null =
          targetElement.match(interstitialLink)
        if (interstitialLinksFound && interstitialLinksFound.length > 0) {
          element.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault()
            const newWindow: Window | null = globalThis.open()
            window.ampInterstitialWindowReference = newWindow
            if (newWindow !== null) {
              newWindow.location.href = targetElement
            }
          })
        }
      }
    })
  })
})()
